import React, { useEffect, useMemo, useRef, useState } from "react";
import { useAuth } from "../../context/auth.context.js";
import { useWebSocket } from "../../context/websocket.context.js";
import { useSnackbar } from "../../context/snackbar.context.js";
import { getGlobalChat, sendGlobalChat } from "../../api/chat.api.js";
import { getUsersLight } from "../../api/user.api.js";
import {
  Box,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import MessageCard from "../../components/cards/message.card.js";
import dayjs from "dayjs";

const ChatPage = () => {
  const [messages, setMessages] = useState([]);
  const [users, setUsers] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [lastMessage, SetLastMessage] = useState();
  const auth = useAuth();
  const websocket = useWebSocket();
  const showSnackbar = useSnackbar();
  const messagesEndRef = useRef(null);

  const [formData, setFormData] = useState({
    message: "",
  });

  useEffect(() => {
    if (!websocket || !websocket.message) {
      return;
    }
    if (JSON.stringify(websocket.message) === JSON.stringify(lastMessage)) {
      return;
    }
    if (websocket.message.Type === "ChatMessage") {
      SetLastMessage(websocket.message);
      setRefresh((prev) => !prev);
    }
  }, [websocket]);

  useEffect(() => {
    websocket.setChatRead(true);
    getGlobalChat()
      .then((response) => setMessages(response.data))
      .catch((error) => console.log(error));
  }, [refresh]);

  useEffect(() => {
    getUsersLight(
      Array.from(new Set(messages.map((message) => message.userId)))
    )
      .then((response) => setUsers(response.data))
      .catch((error) => console.log(error));
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const getUser = (userId) => {
    return users.find((user) => user.id === userId);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!formData.message.trim()) return;
    sendGlobalChat({
      message: formData.message,
      userId: auth.user.id,
      timeStamp: dayjs(),
    }).then(() => showSnackbar("Message sent!", "success"));
    setFormData({ message: "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <Box
      className="dashboard-container"
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "95vh",
      }}
    >
      <Box>
        <Typography variant="h3" gutterBottom>
          Chat
        </Typography>
        <Divider sx={{ mt: 1, mb: 1 }} />
      </Box>
      <Box sx={{ flexGrow: 1, overflowY: "auto", padding: 2 }}>
        <Stack spacing={1}>
          {messages &&
            messages.length > 0 &&
            messages.map((message) => (
              <MessageCard
                key={message.timeStamp}
                user={getUser(message.userId)}
                message={message}
              />
            ))}
          <div ref={messagesEndRef} />
        </Stack>
      </Box>

      <Divider sx={{ mt: 1, mb: 1 }} />
      <Box>
        <form onSubmit={onSubmit}>
          <TextField
            id="message"
            label="New message"
            name="message"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={formData.message}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                onSubmit(e);
              }
            }}
            onChange={(e) => handleChange(e)}
          />
          <Button type="submit" variant="contained" sx={{ mt: 1 }}>
            Send
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default ChatPage;
